import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { BsFillCartPlusFill } from 'react-icons/bs';

import ViewImage from 'modules/common/Img/components/ViewImage';
import { Button } from 'modules/common/input';

import { useGetCart } from '../../../services/hooks';

function Grid({ data, onClick }) {
  const [cart, , included] = useGetCart();

  const handleOnClick = (row, remaining) => () => {
    if (remaining <= 0) return;

    onClick(row)();
  };

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3">
        {data?.map((item, key) => {
          const existIndex = included?.productExistsIndex(item, {
            override: true,
          });

          let remaining = item?.has_variant
            ? item?.variants_stocks
            : item?.remaining;

          if (item?.type === 'Fixed') remaining = 1;

          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={key}
              className={cn(
                'flex flex-col group border-2 border-transparent leading-tight relative',
                {
                  '!border-primary-500 !rounded': existIndex > -1,
                  'cursor-not-allowed': remaining <= 0,
                  'hover:rounded hover:border-primary-500 cursor-pointer':
                    remaining > 0,
                }
              )}
              onClick={handleOnClick(item, remaining)}
              role="presentation"
            >
              <div className="relative">
                <ViewImage
                  src={item?.photo_url}
                  className="w-full object-cover border rounded"
                  heightClassName="h-28 lg:h-36 xl:h-44"
                  withFooterContent={
                    <div className="text-white text-center">
                      {item?.short_description}
                    </div>
                  }
                  disableLoader
                  enableLightBox
                  stopPropagation
                  labelClassName="-mt-4"
                />

                {remaining <= 0 ? (
                  <div className="absolute bottom-0 w-full bg-primary-300 bg-opacity-90 h-9 transition duration-300 flex">
                    <Button
                      className="flex flex-1 bg-opacity-30  text-white font-semibold  text-sm focus:bg-primary-500 transition-none cursor-not-allowed"
                      label={<div className="m-auto">Out of stock</div>}
                    />
                  </div>
                ) : (
                  <div className="absolute bottom-0 w-full bg-primary-300 bg-opacity-90 hidden group-hover:flex h-9 transition duration-300">
                    <Button
                      className="flex flex-1 bg-opacity-50  text-white font-semibold  text-sm focus:bg-primary-500 transition-none"
                      label={
                        <div className="flex gap-2 items-center m-auto">
                          <BsFillCartPlusFill className="h-4 w-4 -mt-0.5" />
                          <div>Add to Order</div>
                        </div>
                      }
                    />
                  </div>
                )}
              </div>

              {existIndex > -1 && (
                <div className="absolute -top-2 -right-2">
                  <div className="min-w-[23px] p-1.5 bg-primary-500 leading-none text-center rounded-full text-white font-medium z-20 text-xs">
                    {cart?.[existIndex]?.quantity}
                  </div>
                </div>
              )}

              <div className="flex flex-col flex-1 gap-2 p-2">
                <div className="font-medium flex-1 leading-tight text-sm">
                  {item?.name}
                </div>
                <div className="text-gray-500 text-xs lg:text-sm">
                  {item?.has_variant ? (
                    <div>
                      {item?.market_price?.min === item?.market_price?.max
                        ? item?.market_price?.min_human
                        : `${item?.market_price?.min_human} ~ ${item?.market_price?.max_human}`}
                    </div>
                  ) : (
                    <div>{item?.final_price_human}</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

Grid.defaultProps = {
  data: [],
  onClick: () => {},
};

Grid.propTypes = {
  data: PropTypes.instanceOf(Array),
  onClick: PropTypes.instanceOf(Function),
};

export default Grid;
